module.exports = __webpack_public_path__ + "resource/img/image039Dark.a25a0ac9.png";